/* Compare v2: calculator size tabs and the hub industry filter.
   Progressive enhancement only. Without this file the mid-size estimate and every hub card stay visible. */
(function () {
  "use strict";

  document.querySelectorAll("[data-c2-calc]").forEach(function (root) {
    var buttons = root.querySelectorAll("[data-c2-size]");
    var panels = root.querySelectorAll("[data-c2-panel]");
    function show(size) {
      buttons.forEach(function (b) { b.setAttribute("aria-selected", b.getAttribute("data-c2-size") === size ? "true" : "false"); });
      panels.forEach(function (p) { p.hidden = p.getAttribute("data-c2-panel") !== size; });
    }
    buttons.forEach(function (b) {
      b.addEventListener("click", function () { show(b.getAttribute("data-c2-size")); });
    });
    show("mid");
  });

  document.querySelectorAll("[data-c2-hub]").forEach(function (root) {
    var chips = root.querySelectorAll("[data-c2-filter]");
    var cards = root.querySelectorAll("[data-c2-industry]");
    var count = root.querySelector("[data-c2-count]");
    var empties = root.querySelectorAll("[data-c2-empty]");
    function apply(value) {
      var shown = 0;
      cards.forEach(function (card) {
        var match = value === "all" || card.getAttribute("data-c2-industry") === value;
        card.hidden = !match;
        if (match) shown += 1;
      });
      chips.forEach(function (c) { c.setAttribute("aria-pressed", c.getAttribute("data-c2-filter") === value ? "true" : "false"); });
      if (count) count.textContent = shown === cards.length ? shown + " comparisons" : shown + " of " + cards.length + " comparisons";
      empties.forEach(function (e) {
        var grid = e.parentElement;
        var any = false;
        if (grid) grid.querySelectorAll("[data-c2-industry]").forEach(function (card) { if (!card.hidden) any = true; });
        e.classList.toggle("is-shown", !any);
      });
    }
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () { apply(chip.getAttribute("data-c2-filter")); });
    });
    apply("all");
  });
})();
